import _ from 'lodash';
/** 获取北森 部门user */
const getBeisenUser = (target) => {
    let name = '';
    if (!_.isEmpty(target.employeeName)) {
        name = target.employeeName;
        if (!_.isEmpty(target.departmentName)) {
            name += `(${target.departmentName})`;
        }
    }
    return name || target.defaultName || '-';
};
export { getBeisenUser, };
